import axios from 'axios';

export const AUTH_SET = 'auth/set';

export const AUTH_USER_GET = 'auth/user/get';
export const AUTH_USER_SET = 'auth/user/set';
export const AUTH_USER_UPDATE = 'auth/user/update';

const state = {
    user: null,
};

const getters = {
    [AUTH_USER_GET]: ({user}) => user,
};

const actions = {
    [AUTH_USER_UPDATE]: ({commit, state}, data) => {
        return axios.patch(`/api/employees/${state.user.id}`, data)
        .then(({data}) => {
            commit(AUTH_USER_SET, data)
        });
    }
};

const mutations = {
    [AUTH_SET]: (state, {user}) => {
        state.user = user;
    },
    [AUTH_USER_SET]: (state, user) => {
        state.user = user;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
